import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { computed, action } from 'mobx';

import Snackbar from 'material-ui/Snackbar';
import IconButton from 'material-ui/IconButton';
import { Close } from 'mdi-material-ui';

import withAppStore from 'decorators/withAppStore';

@withAppStore
@observer
export default class Message extends Component {

  @computed
  get text() {
    return this.appStore.messageText;
  }

  @computed
  get timeout() {
    return this.appStore.messageTimeout || null;
  }

  @computed
  get isOpen() {
    return !!this.text;
  }

  render() {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={ this.isOpen }
        autoHideDuration={ this.timeout }
        onClose={ this.handleClose }
        message={ this.text }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={ this.handleClose }
          >
            <Close />
          </IconButton>,
        ]}
      />
    );
  }

  @action.bound
  handleClose() {
    this.appStore.messageText = '';
    this.appStore.messageTimeout = null;
  }

}



// WEBPACK FOOTER //
// ./src/components/Message.js